export const coWarehouseTable = [
  {
    source: 'part_whs_id',
    sortable: true,
    title: 'Id',
    selectable: true,
  },
  {
    source: 'part_whs_status',
    sortable: true,
    title: 'Status',
    selectable: true,
  },
  {
    source: 'part_whs_brand',
    sortable: true,
    title: 'Brand',
    selectable: true,
  },
  {
    source: 'part_whs_type',
    sortable: true,
    title: 'Type',
    selectable: true,
  },
  {
    source: 'part_whs_mpn',
    sortable: true,
    title: 'Mpn',
    selectable: true,
  },
  {
    source: 'part_whs_included_type',
    sortable: true,
    title: 'Included',
    selectable: true,
  },
  {
    source: 'part_whs_total_qty',
    sortable: true,
    title: 'Total Qty',
    selectable: true,
  },
  {
    source: 'part_whs_available_qty',
    sortable: true,
    title: 'Available Qty',
    selectable: true,
  },
  {
    source: 'part_whs_reserved_qty',
    sortable: true,
    title: 'Reserved Qty',
    selectable: true,
  },
  {
    source: 'part_whs_average_monthly_used',
    sortable: true,
    title: 'Monthly used',
    selectable: true,
  },
  {
    source: 'part_whs_ordered_qty',
    sortable: true,
    title: 'Ordered',
    selectable: true,
  },
  {
    source: 'part_whs_need_for_order_qty',
    sortable: true,
    title: 'Need for Orders',
    selectable: true,
  },
  {
    source: 'part_whs_min_qty',
    sortable: true,
    title: 'Min qty',
    selectable: true,
  },
  {
    source: 'part_whs_max_qty',
    sortable: true,
    title: 'Max qty',
    selectable: true,
  },
  {
    source: 'part_whs_ordered_needed_status',
    sortable: true,
    title: 'To Order Status',
    selectable: true,
  },
  {
    source: 'part_whs_to_order',
    sortable: true,
    title: 'To Order',
    selectable: true,
  },
  {
    source: 'part_whs_order_for_orders',
    sortable: true,
    title: 'Order for orders',
    selectable: true,
  },
  {
    source: 'part_whs_price',
    sortable: true,
    title: 'Price',
    selectable: true,
  },
  {
    source: 'part_whs_shipping_length',
    sortable: true,
    title: 'Shipping Length',
    selectable: true,
  },
  {
    source: 'part_whs_shipping_width',
    sortable: true,
    title: 'Shipping Width',
    selectable: true,
  },
  {
    source: 'part_whs_shipping_height',
    sortable: true,
    title: 'Shipping Height',
    selectable: true,
  },
  {
    source: 'part_whs_shipping_weight',
    sortable: true,
    title: 'Shipping Weight',
    selectable: true,
  },
  {
    source: 'part_whs_total_used',
    sortable: true,
    title: 'Total used',
    selectable: true,
  },
  {
    source: 'part_whs_return_qty',
    sortable: true,
    title: 'Return Qty',
    selectable: true,
  },
  {
    source: 'part_whs_location',
    sortable: true,
    title: 'Location',
    selectable: true,
  },
  {
    source: 'part_whs_note',
    sortable: false,
    title: 'Note',
    selectable: true,
  },
];

export default coWarehouseTable;
